import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/**
 * @jsxRuntime classic
 * @jsx jsx
 */

import React, { useEffect, useMemo, useState } from 'react';

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css, jsx } from '@emotion/react';
import debounce from 'lodash/debounce';
import { fg } from '@atlaskit/platform-feature-flags';
var statusDebounceMillis = 1400;
var assitiveTextStyles = css({
  border: 0,
  clip: 'rect(0 0 0 0)',
  height: '1px',
  marginbottom: '-1px',
  marginright: '-1px',
  overflow: 'hidden',
  padding: 0,
  position: 'absolute',
  whitespace: 'nowrap',
  width: '1px'
});

// Ignored via go/ees005
// eslint-disable-next-line @repo/internal/react/no-class-components
var AssistveTextOld = /*#__PURE__*/function (_React$Component) {
  function AssistveTextOld() {
    var _this;
    _classCallCheck(this, AssistveTextOld);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, AssistveTextOld, [].concat(args));
    _defineProperty(_this, "state", {
      bump: false,
      //when the same text needs to be read again, Hence it needs to be toggled between __status--A and __status--B
      debounced: false,
      silenced: false
    });
    return _this;
  }
  _inherits(AssistveTextOld, _React$Component);
  return _createClass(AssistveTextOld, [{
    key: "UNSAFE_componentWillMount",
    value: function UNSAFE_componentWillMount() {
      var _this2 = this;
      this.debounceStatusUpdate = debounce(function () {
        if (!_this2.state.debounced) {
          var shouldSilence = !_this2.props.isInFocus;
          _this2.setState(function (_ref) {
            var bump = _ref.bump;
            return {
              bump: !bump,
              debounced: true,
              silenced: shouldSilence
            };
          });
        }
      }, statusDebounceMillis);
    }
  }, {
    key: "UNSAFE_componentWillUnmount",
    value: function UNSAFE_componentWillUnmount() {
      this.debounceStatusUpdate.cancel();
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps() {
      this.setState(function (_ref2) {
        var bump = _ref2.bump;
        return {
          bump: !bump,
          debounced: false
        };
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        assistiveText = _this$props.assistiveText,
        id = _this$props.id;
      var _this$state = this.state,
        bump = _this$state.bump,
        debounced = _this$state.debounced,
        silenced = _this$state.silenced;
      this.debounceStatusUpdate();
      return jsx("div", {
        css: assitiveTextStyles
      }, jsx("div", {
        "data-testId": id + '__status--A',
        id: id + '__status--A',
        role: "status",
        "aria-atomic": "true",
        "aria-live": "polite"
      }, "".concat(!silenced && debounced && bump ? assistiveText : '')), jsx("div", {
        "data-testId": id + '__status--B',
        id: id + '__status--B',
        role: "status",
        "aria-atomic": "true",
        "aria-live": "polite"
      }, "".concat(!silenced && debounced && !bump ? assistiveText : '')));
    }
  }]);
}(React.Component);
_defineProperty(AssistveTextOld, "defaultProps", {
  statusDebounceMillis: 1400,
  debounce: true,
  assistiveText: '',
  isInFocus: false,
  id: ''
});
export var AssistiveTextNew = function AssistiveTextNew(_ref3) {
  var _ref3$assistiveText = _ref3.assistiveText,
    assistiveText = _ref3$assistiveText === void 0 ? '' : _ref3$assistiveText,
    _ref3$isInFocus = _ref3.isInFocus,
    isInFocus = _ref3$isInFocus === void 0 ? false : _ref3$isInFocus,
    _ref3$id = _ref3.id,
    id = _ref3$id === void 0 ? '' : _ref3$id,
    _ref3$statusDebounceM = _ref3.statusDebounceMillis,
    statusDebounceMillis = _ref3$statusDebounceM === void 0 ? 1400 : _ref3$statusDebounceM;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    bump = _useState2[0],
    setBump = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    debounced = _useState4[0],
    setDebounced = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    silenced = _useState6[0],
    setSilenced = _useState6[1];
  var debounceStatusUpdate = useMemo(function () {
    return debounce(function () {
      var shouldSilence = !isInFocus;
      setBump(function (prevBump) {
        return !prevBump;
      });
      setDebounced(true);
      setSilenced(shouldSilence);
    });
  }, [isInFocus]);
  useEffect(function () {
    if (!debounced) {
      debounceStatusUpdate();
      return function () {
        debounceStatusUpdate.cancel();
      };
    }
  }, [assistiveText, isInFocus, debounced, debounceStatusUpdate]);
  useEffect(function () {
    if (debounced) {
      setBump(function (prevBump) {
        return !prevBump;
      });
      setDebounced(true);
      setSilenced(!isInFocus);
    }
  }, [assistiveText, isInFocus, debounced]);
  return jsx("div", {
    css: assitiveTextStyles
  }, jsx("div", {
    "data-testid": id + '__status--A',
    id: id + '__status--A',
    role: "status",
    "aria-atomic": "true",
    "aria-live": "polite"
  }, !silenced && debounced && bump ? assistiveText : ''), jsx("div", {
    "data-testid": id + '__status--B',
    id: id + '__status--B',
    role: "status",
    "aria-atomic": "true",
    "aria-live": "polite"
  }, !silenced && debounced && !bump ? assistiveText : ''));
};
export var AssistiveText = function AssistiveText(props) {
  if (fg('platform_editor_react18_phase2_v2')) {
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return jsx(AssistiveTextNew, props);
  } else {
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return jsx(AssistveTextOld, props);
  }
};